const BASE_PAGINATION_CLASSES = 'w-full min-w-0 overflow-x-auto bg-light-bg-primary py-3 dark:bg-dark-bg-secondary sm:overflow-x-visible sm:px-4';

export function getTalentListPaginationClassName(sticky = false) {
  if (!sticky) {
    return `${BASE_PAGINATION_CLASSES} rounded-b-lg px-2`;
  }

  return `${BASE_PAGINATION_CLASSES} sticky bottom-0 z-20 rounded-lg border border-light-border-primary pl-2 pr-8 shadow-[0_-4px_12px_rgba(15,23,42,0.10)] dark:border-dark-border-primary sm:pr-4`;
}
